export enum SortDirection {
    NONE = 0,
    ASC = 1,
    DESC = 2
}
